import React, { useState } from "react";

const AccountAgre = () => {
    const [url, setUrl] = useState("");
    const [showButton, setShowButton] = useState(true);

    const handleOpenURL = () => {
        setUrl("https://staging.d17rufy69m3xev.amplifyapp.com");
        setShowButton(false);
    };

    const handleCloseURL = () => {
        setUrl("");
        setShowButton(true);
    };

    const hha = ()=>{

        
    }

    return (
        <div className="flex flex-col justify-center items-center h-screen space-y-6 bg-gray-100">
            {showButton && (
                <button
                    onClick={handleOpenURL}
                    className="px-8 py-3 text-black text-lg font-bold rounded-xl border border-[#ef4f28] bg-[#ef4f28] shadow-md hover:scale-105 transition-transform duration-300"
                    style={{ backgroundColor: "#ef4f28", border: "1px solid #ef4f28" }}
                >
                    🚀 Start Account Aggregator Process
                </button>
            )}

            {url && (
                <div className="relative flex justify-center items-center w-full">
                    {/* Close Button */}
                    <button
                        onClick={handleCloseURL}
                        className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-full shadow-md hover:bg-red-600 transition-all"
                        style={{ backgroundColor: "#ef4f28", border: "1px solid #ef4f28" }}

                    >
                        ✖ Close
                    </button>

                    {/* Iframe */}
                    <iframe
                        src={url}
                        title="RPD Process"
                        style={{
                            width: "70vw",
                            height: "65vh",
                            border: "2px solid #ccc",
                            borderRadius: "12px",
                            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default AccountAgre;
